import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import userService from "../../services/userService"; // IMPORT USER SERVICE
import "./Signin.css";

function SignIn() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // call userService instead of axios
      const res = await userService.loginUser(formData);
    console.log(res)
      // store token and username
      localStorage.setItem("token", res.token);
      localStorage.setItem("username", res.username);

      navigate("/home");
    } catch (error) {
      alert(error.message || "Login failed");
    }
  };

  return (
    <div className="auth-wrapper">
      {/* LEFT LOGIN CARD */}
      <div className="auth-card">
        <h3 className="auth-title">Login to your account</h3>
        <p className="auth-subtext">
          Don’t have an account?{" "}
          <span
            className="auth-link"
            style={{ cursor: "pointer", color: "#007bff" }}
            onClick={() => navigate("/signup")}
          >
            Create a new account
          </span>
        </p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email address"
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />
          <div className="forgot-text">Forgot password?</div>
          <button type="submit" className="auth-btn">Login</button>
        </form>
      </div>

      {/* RIGHT ABOUT SECTION */}
      <div className="auth-about">
        <h4>About</h4>
        <h1>Evangadi Networks</h1>
        <p>
          No matter what stage of life you are in, whether you’re just starting
          elementary school or being promoted to CEO of a Fortune 500 company,
          you have much to offer to those who are trying to follow in your
          footsteps.
        </p>
        <p>
          Whether you are willing to share your knowledge or you are just
          looking to meet mentors of your own, please start by joining the
          network here.
        </p>
        <button className="how-btn">HOW IT WORKS</button>
      </div>
    </div>
  );
}

export default SignIn;
